import React from "react";
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const NeedHelpIcon = () => {
  return (
    <Tooltip
      title={
        <>
          Trenger du hjelp? Send mail til{" "}
          <a href="mailto:kontakt@bindeleddet.no" style={{ color: "white" }}>
            kontakt@bindeleddet.no
          </a>
        </>
      }
    >
      <QuestionCircleOutlined style={{ fontSize: "1.3em", color: "grey", padding: "8px" }} />
    </Tooltip>
  );
};

export default NeedHelpIcon;
